import { NAMESPACE, useLang } from '@/hooks/use-lang';
import React from 'react';
import { useProductDetailStore } from '../store';
import '../index.scss';
import { hazardSymbolMapping } from '../constants';
import Image from 'next/image';

export const ProductDescription = () => {
  const { t } = useLang(NAMESPACE.pdp);
  const { productDetail } = useProductDetailStore();
  const { description, productFeatures, properties, hazardStatementsCode, precautionaryStatementsCode, disclaimer } =
    productDetail;
  const { HAZARD_STATEMENTS, PRECAUTIONARY_STATEMENTS, HAZARD_SYMBOL, OTHER_REFERENCES, RISK_SAFETY } = properties;
  return (
    <div className="product-description">
      <div>
        <h2 className="text-[26px] leading-8 font-medium text-[#222]">{t('description')}</h2>
        <div
          className="mt-5 text-sm text-gray-1100 leading-[22px] "
          dangerouslySetInnerHTML={{ __html: description }}
        ></div>
      </div>
      {productFeatures && (
        <div
          className="mt-[50px] product-features text-sm font-normal text-gray-1100 leading-[22px]"
          dangerouslySetInnerHTML={{ __html: productFeatures }}
        ></div>
      )}
      {OTHER_REFERENCES && OTHER_REFERENCES.length > 0 && (
        <div className="mt-[50px]">
          <h2>{t('other.references')}</h2>
          <p className="mt-5 grid grid-cols-2 gap-x-[110px] w-fit leading-[22px]">
            {OTHER_REFERENCES.map((item, index) => (
              <React.Fragment key={index}>
                <span className="w-fit">{item.displayName}:</span>
                <span className="w-fit" dangerouslySetInnerHTML={{ __html: item.value }} />
              </React.Fragment>
            ))}
          </p>
        </div>
      )}

      <div className="mt-[50px]">
        <h2>{t('GHS.hazard.and.precautionary.statements')}</h2>
        <div className="mt-5">
          <div className="text-base mb-1">
            <span className="mr-1 text-sm font-medium leading-[22px]">{t('hazard.statements')}</span>
            {(
              <span
                className=" text-sm font-normal leading-[22px]"
                dangerouslySetInnerHTML={{ __html: hazardStatementsCode }}
              />
            ) ?? ''}
          </div>
          {HAZARD_STATEMENTS &&
            HAZARD_STATEMENTS.length > 0 &&
            HAZARD_STATEMENTS.map((item, index) => <div key={index}>{item.value}</div>)}
        </div>
        {((PRECAUTIONARY_STATEMENTS && PRECAUTIONARY_STATEMENTS.length > 0) || precautionaryStatementsCode) && (
          <div className="mt-5">
            <div className="text-base mb-1">
              <b className="mr-1 text-sm font-medium leading-[22px]">{t('precautionary.statements')}</b>
              <span
                className="text-sm font-normal leading-[22px]"
                dangerouslySetInnerHTML={{ __html: precautionaryStatementsCode ?? '' }}
              ></span>
            </div>
            {PRECAUTIONARY_STATEMENTS &&
              PRECAUTIONARY_STATEMENTS.length > 0 &&
              PRECAUTIONARY_STATEMENTS.map((item, index) => (
                <div key={index} dangerouslySetInnerHTML={{ __html: item.value }} />
              ))}
          </div>
        )}
        {HAZARD_SYMBOL && HAZARD_SYMBOL.length > 0 && (
          <div className="mt-8 flex gap-x-8 hazard-symbol">
            {HAZARD_SYMBOL.map((item, index) => {
              return hazardSymbolMapping[item.value] ? (
                <Image key={index} src={hazardSymbolMapping[item.value]} width={110} height={110} alt="" />
              ) : null;
            })}
          </div>
        )}
        {RISK_SAFETY && RISK_SAFETY.length > 0 && (
          <div className="mt-[50px]">
            <h2 className="text-[26px] leading-8 font-medium text-[#222]">{t('risk.safety')}</h2>
            <div className="sm:flex sm:flex-col sm:gap-y-2 w-full mt-5 text-sm text-gray-1100 grid grid-cols-[auto_auto_1fr] gap-x-[110px] gap-y-5">
              {RISK_SAFETY.map((item, index) => (
                <React.Fragment key={index}>
                  {item.displayName !== 'WARNING underline' && (
                    <React.Fragment>
                      <span className="w-fit col-span-1 font-medium">{item.displayName}:</span>
                      <span className="w-fit col-span-1" dangerouslySetInnerHTML={{ __html: item.value }} />
                      <span className="col-span-1"></span>
                    </React.Fragment>
                  )}
                  {item.displayName === 'WARNING underline' && (
                    <div className="sm:flex sm:flex-col w-1/2 text-sm bg-gray-100 py-4 pl-8 inline-block mt-5 col-span-3">
                      <span className="font-bold mr-1 leading-[22px]">{t('warning')}</span>
                      <span dangerouslySetInnerHTML={{ __html: item.value }} />
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        )}

        {/* <div className="text-sm min-w-[700px] bg-gray-100 py-4 pl-8 inline-block mt-4">{disclaimer}</div> */}
      </div>
    </div>
  );
};
